import React from 'react';
import { randomString } from 'helpers/string';
import PublicNoticesSearchPage from 'components/PublicNotices/PublicNoticesSearchPage';
import { APP_CONFIG } from 'Config';
import Error404 from 'components/Errors/Error404';

const OnlineSearch = () => {
    if (!APP_CONFIG.RELEASE_PUBLIC_NOTICE) {
        return <Error404 />;
    }

    return <PublicNoticesSearchPage />;
};

OnlineSearch.getInitialProps = async ({ res }) => {
    if (!APP_CONFIG.RELEASE_PUBLIC_NOTICE) {
        if (res) {
            res.statusCode = 404;
        }
        return {};
    }

    const rand_str = randomString();
    const pageData = { title: 'Public Notice Ads', marginBottom: 'pageTitle marginB20', h1: 'Public Notice Ads', description: undefined };

    return { rand_str, pageData };
};

export default OnlineSearch;